import Button from 'react-bootstrap/Button';
import { useUserData } from '../hooks/useUserData';
import { ProxyApi } from '../api/rndApi';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UpsellSuccessModal } from '../components/UpsellSuccessModal';
import { SHOP_UPSELLS } from '../constants/shop';
import FIRST_UPSELL from '../assets/images/first_upsell.jpg';

const keyframes = `
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }
`;

const Skeleton = ({ width, height, style, className }) => {
  const skeletonStyle = {
    backgroundColor: '#e0e0e0',
    borderRadius: '4px',
    animation: 'pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    width,
    height,
    ...style,
  };

  return (
    <>
      <style>{keyframes}</style>
      <div style={skeletonStyle} className={className} />
    </>
  );
};

const FirstUpsell = ({ onPress }) => {
  const { t } = useTranslation();
  const { userData } = useUserData();
  const productId = 'product-digital-book-credits-v1-plus2x';

  const [upsellLoading, setUpsellLoading] = useState(true);
  const [upsell, setUpsell] = useState(null);
  const [upsellUrl, setUpsellUrl] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    if (!userData || !userData?.code || !upsellLoading) return;

    (async () => {
      try {
        const response = await ProxyApi.fetchUpsells(userData?.code);
        const product = response?.data.find((u) => u.key === productId);
        setUpsell(product);
        setUpsellUrl(response?.upsell_urls[productId]);
      } catch (error) {
        console.error(error);
      } finally {
        setUpsellLoading(false);
      }
    })();
  }, [userData, upsellLoading, productId]);

  const handleBuy = () => {
    setShowSuccessModal(true);
  };

  const completeOrder = () => {
    onPress();
  };

  const initialPrice = upsell?.prices[0]?.price;
  const finalPrice = upsell?.prices[0]?.final_price;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <h2 style={{ marginBottom: 28 }}>{t('firstUpsell.title')}</h2>
      <img
        src={FIRST_UPSELL}
        alt="Memowrite Upsell Offer"
        style={{ width: '100%', marginBottom: 20 }}
        className="d-block d-lg-none"
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}
      >
        <img
          src={FIRST_UPSELL}
          alt="Memowrite Upsell Offer"
          style={{ width: 400, marginRight: 24, borderRadius: 12 }}
          className="d-none d-lg-block"
        />
        <div>
          <p>
            <b>{t('firstUpsell.congratulations')}</b>
          </p>
          <p>{t('firstUpsell.oneTimeOffer')}</p>
          <p>{t('firstUpsell.customerStats')}</p>
          <p style={{ marginBottom: 32 }}>
            <b>{t('firstUpsell.completeExperience')}</b>
          </p>
          {upsellLoading ? (
            <>
              <Skeleton
                width="250px"
                height="16px"
                style={{ marginBottom: 8 }}
              />
              <Skeleton
                width="200px"
                height="40px"
                style={{ marginBottom: 16 }}
              />
              <Skeleton width="100%" height="54px" />
            </>
          ) : (
            <>
              <span
                style={{
                  backgroundColor: '#4caf50',
                  color: '#fff',
                  padding: '4px 12px',
                  borderRadius: '4px',
                  fontSize: '14px',
                  fontWeight: 600,
                }}
              >
                <b>{t('firstUpsell.saveNow')}</b>
              </span>
              <p style={{ fontSize: 32 }}>
                <b>
                  <span
                    style={{
                      fontSize: '18px',
                      color: '#444',
                      textDecoration: 'line-through',
                    }}
                  >
                    ${initialPrice}
                  </span>{' '}
                  <span
                    style={{
                      fontSize: '32px',
                      fontWeight: 600,
                      color: '#d32f2f',
                    }}
                  >
                    ${finalPrice}
                  </span>
                </b>
              </p>
              <Button
                className="button-update mt-2 pt-3 pb-3"
                onClick={handleBuy}
                style={{
                  width: '100%',
                  backgroundColor: '#60A680',
                  borderColor: '#60A680',
                  color: 'white',
                }}
              >
                {t('firstUpsell.getItNow', { price: finalPrice })}
              </Button>
            </>
          )}
          {upsellLoading ? (
            <Skeleton width="250px" height="16px" style={{ marginTop: 8 }} />
          ) : (
            <Button
              variant="link"
              style={{
                color: 'black',
                textAlign: 'center',
                width: '100%',
              }}
              className="mt-2"
              onClick={onPress}
            >
              {t('firstUpsell.notInterested')}
            </Button>
          )}
          <p className="mt-4">{t('firstUpsell.uniqueOpportunity')}</p>
          <p>
            <b>{t('firstUpsell.exclusiveReminder')}</b>
          </p>
        </div>
      </div>

      {upsell && (
        <UpsellSuccessModal
          onHide={() => setShowSuccessModal(false)}
          onComplete={completeOrder}
          upsellPurchaseUrl={upsellUrl}
          upsellImage={FIRST_UPSELL}
          visible={showSuccessModal}
        />
      )}
    </div>
  );
};

export default FirstUpsell;
